import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
  export class UtilitiesService {
      public IsStringNullOrEmpty(str: string | null | undefined): boolean {
        return str === null || str === undefined || str.match(/^ *$/) !== null;
      }
  }